// Rails UJS (to use link_to with method: "XYZ")
import Rails from "@rails/ujs"
// ActiveStorage
import * as ActiveStorage from "@rails/activestorage"
// Stimulus
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import "flatpickr/dist/flatpickr.min.css"

import application from "../src/stimulus"
import { startTomSelects } from "../src/tom_select"

application.load(definitionsFromContext(require.context("../backend_controllers", true, /\.js$/)))
startTomSelects()

ActiveStorage.start()
Rails.start()
